export default __webpack_public_path__ + "static/media/Visa-Color.6676011a.svg";